import React from 'react';
import { Typography } from '@vtblife/uikit';

import { cn } from '../../index2';

export const StaticSectionItem = ({
    label,
    value,
    children
}: React.PropsWithChildren<{
    value?: React.ReactNode;
    label: React.ReactNode;
}>) => {
    return (
        <>
            <StaticSectionItemLabel>{label}</StaticSectionItemLabel>
            <StaticSectionItemValue>{value ?? children}</StaticSectionItemValue>
        </>
    );
};

export const StaticSectionItemLabel = ({
    children
}: {
    children: React.ReactNode;
}) => {
    return (
        <Typography
            color='secondary'
            className={cn('staticSection-item-label')}
        >
            {children}
        </Typography>
    );
};

export const StaticSectionItemValue = ({
    children
}: {
    children?: React.ReactNode;
}) => {
    return (
        <Typography
            bold
            className={cn('staticSection-item-value')}
        >
            {children}
        </Typography>
    );
};
